import React, { useEffect, useState } from "react";
import { Link } from "react-scroll";
import { gsap, Elastic } from "gsap";
import "./style.css";
import Logo from "../../components/SVGS/logo";
import Social from "../../components/Social-icons";

export default function Header() {
  const tl = gsap.timeline();
  const targetWidth = 1000;
  const w =
    document.documentElement.clientWidth ||
    document.body.clientWidth ||
    window.innerWidth;

  const [fixedState, setFixedState] = useState({
    isFixed: false,
  });

  const [menuOpen, setMenuOpen] = useState(false); // new state for hamburger toggle

  function setFixed() {
    setFixedState((state) => ({
      isFixed: !state.isFixed,
    }));
  }

  // useEffect(() => {
  //   const onScroll = () => {
  //     const isTop = window.scrollY < 400;
  //     if (isTop === fixedState.isFixed) {
  //       setFixedState({
  //         isFixed: true,
  //       });
  //     } else {
  //       setFixedState({
  //         isFixed: false,
  //       });
  //     }
  //   };

  //   window.addEventListener("scroll", onScroll);

  //   if (w >= targetWidth) {
  //     tl.from("header", {
  //       delay: 4,
  //       duration: 1,
  //       ease: Elastic.easeInOut,
  //       y: -150,
  //     });
  //   } else {
  //     console.log("header too small");
  //   }

  //   return () => {
  //     window.removeEventListener("scroll", onScroll);
  //   };
  // }, [fixedState.isFixed, tl, w]);

  // toggle hamburger menu open state
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header className="transition">
      <Link to="/">
        <Logo className="logo" />
      </Link>

      {/* Hamburger icon/button */}
      <button
        className={`hamburger ${menuOpen ? "open" : ""}`}
        onClick={toggleMenu}
        aria-label="Toggle menu"
        aria-expanded={menuOpen}
      >
        <span />
        <span />
        <span />
      </button>

      {/* Navigation: add class to show/hide based on menuOpen */}
      <nav className={menuOpen ? "nav-open" : ""}>
        <Link
          activeClass="active"
          to="calendar"
          spy={true}
          smooth={true}
          offset={-103}
          duration={500}
          className="transition"
          onClick={() => setMenuOpen(false)} // close menu on link click
        >
          Book a session
        </Link>
        <Link
          activeClass="active"
          to="services"
          spy={true}
          smooth={true}
          duration={500}
          className="transition"
          onClick={() => setMenuOpen(false)}
        >
          Services
        </Link>
        <Link
          activeClass="active"
          to="clients"
          spy={true}
          smooth={true}
          offset={-103}
          duration={500}
          className="transition"
          onClick={() => setMenuOpen(false)}
        >
          Clients
        </Link>
        <Link
          activeClass="active"
          to="name-container"
          spy={true}
          smooth={true}
          offset={-103}
          duration={500}
          className="transition"
          onClick={() => setMenuOpen(false)}
        >
          Meet the team
        </Link>
        <Link
          activeClass="active"
          to="footer"
          spy={true}
          smooth={true}
          offset={-103}
          duration={500}
          className="transition"
          onClick={() => setMenuOpen(false)}
        >
          Get in touch
        </Link>
      </nav>

      <Social />
    </header>
  );
}
